export enum MaxUnitType {
  hours = 'hours',
  allUnits = 'all',
}
